"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.chainValidation = exports.providerConnectionInfoValidation = exports.chainNamespaceValidation = exports.chainIdValidation = exports.validate = void 0;
var joi_1 = __importDefault(require("joi"));
function validate(validator, data) {
    var result = validator.validate(data);
    return result.error ? result : null;
}
exports.validate = validate;
exports.chainIdValidation = joi_1["default"].alternatives()["try"](joi_1["default"].string().pattern(/^0x[0-9a-fA-F]+$/), joi_1["default"].number().positive());
exports.chainNamespaceValidation = joi_1["default"].string().valid('evm');
/** Related to ConnectionInfo from 'ethers/lib/utils' */
exports.providerConnectionInfoValidation = joi_1["default"].object({
    url: joi_1["default"].string().required(),
    headers: joi_1["default"].object(),
    user: joi_1["default"].string(),
    password: joi_1["default"].string(),
    allowInsecureAuthentication: joi_1["default"].boolean(),
    allowGzip: joi_1["default"].boolean(),
    throttleLimit: joi_1["default"].number(),
    throttleSlotInterval: joi_1["default"].number(),
    throttleCallback: joi_1["default"]["function"](),
    timeout: joi_1["default"].number()
});
exports.chainValidation = joi_1["default"].object({
    namespace: exports.chainNamespaceValidation,
    id: exports.chainIdValidation.required(),
    rpcUrl: joi_1["default"].string().required(),
    label: joi_1["default"].string().required(),
    token: joi_1["default"].string().required(),
    icon: joi_1["default"].string(),
    color: joi_1["default"].string(),
    publicRpcUrl: joi_1["default"].string(),
    blockExplorerUrl: joi_1["default"].string(),
    providerConnectionInfoValidation: exports.providerConnectionInfoValidation
});
